// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext } from 'react';
export const defaultValue = {
    defaultVariant: 'secondary',
};
export const LinkDefaultVariantContext = createContext(defaultValue);
//# sourceMappingURL=link-default-variant-context.js.map